module.exports = " <div class=platform-protocol _v-2b4298ba=\"\"> <hd title=证照信息 _v-2b4298ba=\"\"></hd> <div _v-2b4298ba=\"\"> <img alt=license_information :src=\"oss_url + '/car_rental/license_information/license_information.jpg'\" _v-2b4298ba=\"\"> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-2b4298ba&file=license_information.vue!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/static_page/license_information.vue
// module id = 647
// module chunks = 13